import {Component, Property, CollisionEventType} from '@wonderlandengine/api';
import {vec3} from 'gl-matrix';

/**
 * seq1-door-photo
 */
export class Seq1DoorPhoto extends Component {
    static TypeName = 'seq1-door-photo';
    /* Properties that are configurable in the editor */
    static Properties = {
        photoObj: Property.object(),
        toObj: Property.object(),
        levelManager: Property.object(),
        knockSFX: Property.object(),
    };

    start() {
        //Audio "Door-Knock"
        //Audio "Slide & Walk-SFX" & Stop "Door-Knock"
        //Photo Slide onCollision [ok]
        //Photo Grabbable & Holding onClick [ok]
        //Blink to Photo Inspect [ok]
        //Blink to Note Writing [ok]
        //Blink to ContinueGame. [ok]

        /* Lerp */
        this.lerpTime = 100;
        this.onCollisionBeginGate = false;

        /* Store Transform */
        this.photoObjTransform = this.photoObj.getTransformWorld();
        this.photoObjPosition = this.photoObj.getPositionWorld();
        this.toObjPosition = this.toObj.getPositionWorld();

        /* Physx Collision */
        this.rigidBody = this.object.getComponent('physx');
        this.rigidBody.onCollision(function(type, other) {
            /* Ignore onCollision Ends */
            if(type == CollisionEventType.TriggerTouchLost) return;

            /* onCollision Begin */
            this.onCollisionBegin(type, other);
        }.bind(this));

        this.i = 0;
    }

    update(dt) {
        /* Lerp toObjPosition */
        this.lerpTime += dt;
        this.lerpRatio = this.lerpTime / 0.5; /* Seconds */
        if (this.lerpTime < 0.5){
            this.lerpResult = vec3.lerp(vec3.create(), this.photoObjPosition, this.toObjPosition, this.lerpRatio);
            this.photoObj.setPositionWorld(this.lerpResult);
        }
    }

    onCollisionBegin(type, other) {
        if (this.onCollisionBeginGate) return; /* Gate to call it only once */

        if(other.object.name == 'Player') {
            this.lerpTime = 0; /* Start Lerp */
            this.knockSFX.getComponent('howler-audio-source').stop(); /* Stop DoorKnock SFX */
            this.onCollisionBeginGate = true; /* Close Gate */
        }
    }
}
